module.exports = __webpack_public_path__ + "img/selected4-min.d61d46ad.png";